import { colord } from '@pn/services/utils/color';
import { isString } from 'lodash-es';

export type WebGLRGBA = [number, number, number, number];

/**
 * Convert a CSS color (anything `colord` can parse) into normalized WebGL RGBA.
 * Output channels are floats in the range [0, 1].
 *
 * Examples:
 *   toWebGLRGBA("#ff0000")            -> [1, 0, 0, 1]
 *   toWebGLRGBA("rgba(0, 0, 0, 0.5)") -> [0, 0, 0, 0.5]
 */
export function toWebGLRGBA(input: unknown): WebGLRGBA {
  if (!isString(input)) return [0, 0, 0, 0];

  /* `toRgb()` gives r, g, b in 0..255 and alpha in 0..1 */
  const { r, g, b, a } = colord(input).toRgb();

  return [r / 255, g / 255, b / 255, a];
}
